// 借入相談以降の参照画面
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import MypageReturn from '../../molecules/MypageReturn';

interface Props {
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  guarantors_num: number;
  guarantor_info: GuarantorInfo;
  show_error_nav: boolean;
  display_status: boolean;
  requestModule: (module_name: string) => Promise<any>;
  is_loading: boolean;
}

const BorrowingConsultationContentInquiryGuarantor: React.FC<Props> = ({
  label,
  status_name,
  display_reception_cd,
  guide_text,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  looks_inactive,
  reception_cd,
  guarantors_num,
  guarantor_info,
  show_error_nav,
  display_status,
  requestModule,
  is_loading,
}) => {
  return (
    <>
      <TopArea
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <Reception
        looks_inactive={looks_inactive}
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={requestModule}
        guarantor_info={guarantor_info}
      />
      <MypageReturn is_staff={false} />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default BorrowingConsultationContentInquiryGuarantor;
